import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

import { reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { validateStep6 } from './validations';

import { Field } from 'redux-form';
import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';
import DropDownSelect from '../DropDownSelect';

import {
    Container,
    ButtonGroupWrapper,
    MultipleGroupWrapper,
    MultipleGroupLast
} from '../../containers/DefaultStyles/FormDetails';

const MultipleGroupWrapperFullRowMobile = styled(MultipleGroupWrapper)`
    @media (max-width: 30em) {
        flex-wrap: wrap;

        .fullRowMobile {
            width: calc(100% - 1em);
            flex: none;
            margin-top: 0.75em;
        }
    }
`;

class VoteRegistrationStep6Form extends React.Component {
    constructor(props) {
        super(props);
        this.state = { errors: [] };

        this.clearSubmitErrors = this.clearSubmitErrors.bind(this);
        this.showAllErrors = this.showAllErrors.bind(this);
        this.checkForBlurError = this.checkForBlurError.bind(this);
    }

    checkForBlurError(name) {
        if (this.props.validationErrors.includes(name) && !this.state.errors.includes(name))
            this.setState({ errors: [...this.state.errors, name] });
    }

    showAllErrors(){
        this.setState({ errors: this.props.validationErrors });
    }

    clearSubmitErrors(fieldName) {
        if (fieldName && this.state.errors.includes(fieldName)) {
            this.setState({ errors: this.state.errors.filter(e => e !== fieldName) });
        }
    }

    render() {
        return (
            <Container autocomplete="on" onSubmit={this.props.handleSubmit}>
                <MultipleGroupWrapperFullRowMobile>
                    <Field
                        name="prevPrefix"
                        onBlur={() => this.checkForBlurError('prevPrefix')}
                        submissionError={this.state.errors.includes('prevPrefix')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={DropDownSelect}
                        options={this.props.prefix}
                        defaultOption={'Choose'}
                        label="Prev Prefix"
                        type="text"
                        class={this.state.class}
                    />
                    <Field
                        name="prevFirstName"
                        onBlur={() => this.checkForBlurError('prevFirstName')}
                        submissionError={this.state.errors.includes('prevFirstName')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={InputGroup}
                        type="text"
                        label="Prev First name"
                        placeholder="First Name"
                        autocomplete="off"
                    />
                    <Field
                        name="prevMiddleName"
                        component={InputGroup}
                        type="text"
                        label="Prev Middle name"
                        placeholder="Middle Name"
                        autocomplete="off"
                        class="fullRowMobile"
                    />
                </MultipleGroupWrapperFullRowMobile>
                <MultipleGroupLast>
                    <Field
                        name="prevLastName"
                        onBlur={() => this.checkForBlurError('prevLastName')}
                        submissionError={this.state.errors.includes('prevLastName')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={InputGroup}
                        type="text"
                        label="Prev Last name"
                        placeholder="Last Name"
                        autocomplete="off"
                    />
                    <Field
                        name="prevSuffix"
                        component={DropDownSelect}
                        options={this.props.suffix}
                        defaultOption={'Choose'}
                        label="Prev Suffix"
                        type="text"
                        class={this.state.class}
                    />
                </MultipleGroupLast>
                <ButtonGroupWrapper>
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <Button
                            primary={true}
                            type="submit"
                            label="Continue"
                            disabled={this.props.invalid}
                            onClick={this.showAllErrors}
                        />
                    </TwoGroup>
                </ButtonGroupWrapper>
            </Container>
        );
    }
}

VoteRegistrationStep6Form.propTypes = {
    onBack: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func,
    prefix: PropTypes.array,
    suffix: PropTypes.array,
    validationErrors: PropTypes.object
};

export default compose(
    connect((state,props) => ({
        initialValues: {},
        validationErrors: Object.keys(props.validationErrors || {})
    })),
    reduxForm({
        form: 'voteRegistrationStep6Form',
        validate: validateStep6,
        destroyOnUnmount: false
    })
)(VoteRegistrationStep6Form);
